// Fecha y hora de la orientación en el panel.
//
// Los campos datetime-local trabajan con «AAAA-MM-DDTHH:MM» sin zona horaria;
// el servidor los entiende en hora de Madrid. Aquí se calculan siempre en hora
// de Madrid, aunque el navegador esté en otra zona, para que el valor
// propuesto, el mínimo y el texto de confirmación coincidan con el servidor.

const ZONA = 'Europe/Madrid';
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto',
  'septiembre', 'octubre', 'noviembre', 'diciembre'];
const DIA_HABITUAL = 2;      // martes (domingo = 0)
const HORA_HABITUAL = '10:00';

const dos = (n) => String(n).padStart(2, '0');

// «AAAA-MM-DDTHH:MM» de un instante, en hora de Madrid.
export function aLocal(fecha) {
  if (!fecha) return '';
  const partes = Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONA, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date(fecha)).map(p => [p.type, p.value]));
  return `${partes.year}-${partes.month}-${partes.day}T${partes.hour}:${partes.minute}`;
}

export const ahoraLocal = () => aLocal(new Date());

// Las cadenas «AAAA-MM-DDTHH:MM» se ordenan igual que las fechas.
export const esPasada = (local) => !!local && local <= ahoraLocal();

// El próximo martes a las 10:00 (si hoy es martes, el de la semana que viene).
export function proximaOrientacion() {
  const [y, m, d] = ahoraLocal().slice(0, 10).split('-').map(Number);
  const hoy = new Date(Date.UTC(y, m - 1, d));
  const dias = ((DIA_HABITUAL - hoy.getUTCDay() + 7) % 7) || 7;
  const dia = new Date(hoy.getTime() + dias * 86400000);
  return `${dia.getUTCFullYear()}-${dos(dia.getUTCMonth() + 1)}-${dos(dia.getUTCDate())}T${HORA_HABITUAL}`;
}

// «martes 20 de octubre, 10:00 h», como lo escribe el servidor.
export function textoLocal(local) {
  if (!local) return '';
  const [fecha, hora] = local.split('T');
  const [y, m, d] = fecha.split('-').map(Number);
  const dia = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return `${DIAS[dia]} ${d} de ${MESES[m - 1]}, ${hora.slice(0, 5)} h`;
}
